<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">T<span class="smallcaps">HE </span>M<span class="smallcaps">ISSING <br/>OF </span>C<span class="smallcaps">LAIRDELUNE</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// EE_DABOS_CLAIRDELUNE_ebk_00004.vue?76c4b928